
(function() {

    'use strict';

    /*
    File button directive wraps the input[file] and triggers click on it whenever it's clicked.

    @example
    <label file-btn class="btn btn-action">
        Attach file
        <input type="file">
    </label>

    */
    var fileBtn = function() {
        return {
            restrict: "A",
            replace: false,
            transclude: false,
            link: function(scope, el, attrs) {


                el.prepend('<span class="glyphicon glyphicon-paperclip"></span>'); // icon

                // child input
                var fileInput = angular.element(el[0].querySelector('input[type=file]'));

                fileInput.on("click",function(e){
                    if( angular.isDefined(attrs.disabled) && attrs.disabled != false ){
                        e.preventDefault();
                    }
                    e.stopPropagation();
                });

                // label click
                el.on('click', function(e){
                    e.preventDefault();
                    fileInput.trigger('click');
                });

                // enter or space pressed
                el.on('keypress', function(e){
                    var keyCode = e.which || e.keyCode;
                    if (keyCode == 13 || keyCode == 32) {
                        e.preventDefault();
                        fileInput.trigger('click');
                    }
                });
            }

        };
    }
    angular.module('app').directive('fileBtn', fileBtn);




    var validationFile = function($timeout, $compile) {
        return {
            require: ['ngModel',"^form", "validationFile"],
            scope: true,
            bindToController: {
                fileObject: '=?'
            },
            controllerAs:'ctrl',
            controller: function(){
            },
            link: function (scope, el, attrs, ctrls) {

                var ngModel = ctrls[0];
                var form    = ctrls[1];
                var ctrl    = ctrls[2];

                $timeout(function(){

                    ngModel.$render = function() {
                        $timeout(function(){ // timeout required $modelValue [see ngModel.$modelValue watch] change can be reflected in field value [el.val()]
                            ngModel.$setViewValue( el.val() );
                        });
                    };

                    // alert( form[attrs.name].$dirty );
                    // for some reason $render makes the field dirty ?
                    // form[attrs.name].$setPristine(true);
                    // form[attrs.name].$setDirty(false);
                    // form[attrs.name].$setTouched(false);

                    el.bind('change', function() {
                        // scope.$apply(function() { // there's timeout in $render function now which seems to do the job
                        ngModel.$render();
                        // });
                    });

                });

                // the watch on $modelValue is required while we clear model value
                // (Angular will not clear the file field by default, so we need to do it manually)
                // this should rather be placed in fileBtn directive
                scope.$watch(
                    function(){
                        return ngModel.$modelValue;
                    },
                    function(newVal, oldVal){

                        if(newVal !== oldVal){
                            if(newVal===undefined){
                                $timeout(function(){ // timeout is required for IE 8-10, otherwise it won't clear the model (it works without it on Chrome or IE11)
                                    angular.element(el[0]).val( '' );
                                    ngModel.$setViewValue( '' );
                                });
                            }
                            ctrl.fileObject = el[0].files[0];
                        }
                    },
                    true
                );


                function getIEFileSize( filepath ) {
                    var myFSO = new ActiveXObject("Scripting.FileSystemObject");
                    // var filepath = document.upload.file.value;
                    var thefile = myFSO.getFile(filepath);
                    return thefile.size;
                }

                var fileSizeBytes = function(filePath) {
                    var fSize;
                    if(cssua.ua.ie && parseFloat(cssua.ua.ie) < 10){ // IE 9
                        try {
                            fSize = getIEFileSize( filePath );
                        } catch(e) {
                            console.warn("The file size couldn't be calculated due to your Internet Explorer security settings. It works when \"Initializing and Script ActiveX controls not marked as safe\" is Enabled (or Prompt and allowed by you) in your Internet Security options (Tools > Internet options > Security > Custom Level).");
                            return 'ie_security_problem';
                        }
                    } else {
                        fSize = el[0].files[0].size;
                    }
                    return fSize;
                }

                var fileSize = function(filePath) {
                    // bytesToSize still resides in main.js it's used by Comms Centre messages at the moment
                    // we need to update Comms Centre to the latest xmsUiAttachment solution
                    return ( fileSizeBytes(filePath) == 'ie_security_problem' ? 'ie_security_problem' : bytesToSize(fileSizeBytes(filePath)) );
                }

                var fileName = function(filePath) {
                    var pathSliceValue = filePath.lastIndexOf("\\");
                    return (pathSliceValue == -1) ? filePath : filePath.slice(pathSliceValue+1);
                }

                var fileExtension = function( filePath ) {
                    var pathSliceValue = filePath.lastIndexOf(".");
                    return (pathSliceValue == -1) ? '' : filePath.slice(pathSliceValue+1);
                }


                scope.getFileInfo = function(filepath) {
                    return {
                        path: filepath,
                        name: fileName(filepath),
                        size: fileSize(filepath),
                        sizeBytes: fileSizeBytes(filepath),
                        ngModel: ngModel
                    }
                }

                // VALIDATORS

                // extensions validation
                if(attrs.allowedExtensions && !attrs.allowedExtensions=='') {

                    var allowedExtensions = attrs.allowedExtensions.split(',').map(function(item) { // split and trim
                        return item.trim().toLowerCase();
                    });

                    ngModel.$validators['allowed-extensions'] = function(modelValue, viewValue) {
                        var filePath = modelValue || viewValue,
                            fileExt = filePath ? fileExtension( filePath ) : '';

                        if (filePath && allowedExtensions.indexOf( fileExt.toLowerCase() ) < 0) {
                            return false;
                        }
                        return true;
                    };
                }

                // maximum file size validation
                if (attrs.maxsize) {

                    var maxsize = parseInt(attrs.maxsize);

                    ngModel.$validators.maxsize = function(modelValue, viewValue) {

                        var filePath = modelValue || viewValue,
                            fSize = filePath ? fileSizeBytes(filePath) : 0;

                        // should the following two lines be out of the validator on change?
                        scope.fSize = bytesToSize(fSize);
                        scope.fName = filePath ? fileName(filePath) : '';

                        // 5MB is the file upload limit = 5242880 Bytes
                        if(fSize > maxsize) {
                            // alert('File too large (max. file size is 5MB).'); // validation (?), should we clear the file field in here?
                            return false;
                        }
                        return true;
                    };
                }


            }
        };
    }
    validationFile.$inject = ['$timeout', '$compile'];
    angular.module('app').directive('validationFile', validationFile);


    /* just for file thumbnail display - self explaining */
    var fileThumb = function() {
        return {
            restrict: "EA",
            scope: true,
            bindToController: {
                fileSize: '&',
                fileName: '&',
                fileStatus: '&'
            },
            controllerAs:'ctrl',
            controller: function(){
            },
            replace: false,
            transclude: false,
            template: [
                '<div class="file-thumb">',
                    '<span class="icon-el icon-el-m icon-paperclip"></span>',
                    '<span class="glyphicon glyphicon-trash"></span>',
                '</div>',
                '<div class="file-info">',
                    '<span class="filename ellipsis">{{ctrl.fileName()}}</span>',
                    '<span class="filesize" ng-show="ctrl.fileSize()!=\'ie_security_problem\'">{{ctrl.fileSize()}}</span>',
                    '<span class="filesize" ng-show="ctrl.fileSize()==\'ie_security_problem\'">Unknown <a href="javascript:void(0);" xms-tooltip="The file size couldn\'t be calculated due to Internet Explorer security settings."></a></span>',
                '</div>',
                '<span class="file-status">{{ctrl.fileStatus()}}</span>'
            ].join(''),
            link: function(scope, el, attrs){
                el.addClass('attachment');
            }
        }
    }
    angular.module('app').directive('fileThumb', fileThumb);

}());
